import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

const INTERVAL_MS = 1000;

export default class extends Controller {
  static values = { waited: Number, patience: Number, status: String, until: String };

  connect() {
    this.started = Date.now();
    this.timer = setTimeout(() => this.check(), INTERVAL_MS);
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  async check() {
    if (this.waited() >= this.patienceValue || (await this.ready())) {
      this.reload();
    } else if (this.element.isConnected) {
      this.timer = setTimeout(() => this.check(), INTERVAL_MS);
    }
  }

  async ready() {
    try {
      const response = await fetch(this.statusValue, { headers: { Accept: "application/json" } });
      return response.ok && (await response.json())[this.untilValue];
    } catch (error) {
      return false;
    }
  }

  waited() {
    return this.waitedValue + Math.round((Date.now() - this.started) / 1000);
  }

  reload() {
    if (!this.element.isConnected) return;

    const frame = this.element.closest("turbo-frame");
    const url = new URL((frame && frame.src) || window.location.href, window.location.href);
    url.searchParams.set("waited", this.waited());
    if (frame) {
      frame.src = url;
    } else {
      Turbo.visit(url, { action: "replace" });
    }
  }
}
